<section class="footer py-3 {{getTranslateDefaultLang()}} {{brand()}}">
  <footer>
    <div class="container-fluid">
      <div class="grid-container">

        @if (isAegBrandingCulture()) {
          <img src="https://assets.qnordicsgames.com/image/upload/q_auto/v1/SWEAEGELX25/logo_aeg.png" alt="">
        }

        @if (!isAegBrandingCulture()) {
          <svg version="1.1" id="logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="636.46px" height="146.13px" viewBox="0 0 636.46 146.13" enable-background="new 0 0 636.46 146.13" xml:space="preserve">
            <g id="type" fill="#ffffff">
    <path fill="#ffffff" d="M195.03,85.9v-9.21h30.4V64.95h-30.41v-17.1h32.35V36.14h-44.79v25.17v24.06c0,12.44,5.3,20.96,17.74,22.71
c0.25,0.06,0.49,0.11,0.72,0.11h0.23c1.27,0.14,2.58,0.24,3.94,0.24h23.03v-11.7h-22.92C201.35,96.73,195.03,94.78,195.03,85.9z"></path>
              <polygon points="237.08,70.3 237.08,108.45 249.52,108.45 249.52,70.05 249.52,36.12 237.08,36.12"></polygon>
    <path fill="#ffffff" d="M285.22,54.5c-15.74,0-27.51,10.84-27.51,27.72v0.42c0,16.47,11.36,27.1,27.83,27.1
c7.92,0,15.32-2.19,22.1-9.38l-7.5-7.3c-3.96,3.96-7.82,6.04-14.18,6.04c-9.27,0-15.42-5.42-15.84-13.76h40.85
c0.21-2.08,0.21-4.38,0.21-4.38C311.18,66.27,300.86,54.5,285.22,54.5z M270.43,76.59c0.52-6.36,6.98-11.46,14.8-11.46
c7.3,0,13.24,5.21,13.24,11.46H270.43z"></path>
    <path fill="#ffffff" d="M346.16,65.65c5.63,0,9.8,2.08,13.34,5.73l7.71-8.03c-6.04-6.46-13.24-9.07-21.05-9.07
c-15.84,0-28.56,11.78-28.56,27.83c0,16.05,12.71,27.83,28.56,27.83c7.82,0,15.01-2.61,21.05-9.07l-7.71-8.03
c-3.54,3.65-7.71,5.73-13.34,5.73c-9.17,0-16.16-6.98-16.16-16.47C330.01,72.63,336.99,65.65,346.16,65.65z"></path>
    <path fill="#ffffff" d="M387.41,85.92l-0.01,0V67.46h11.33V56.15h-11.31V36.13h-12.45v25.94v24.59l0.04,0
c0.36,11.75,5.7,19.75,17.71,21.44c0.25,0.06,0.49,0.11,0.72,0.11h0.23c1.27,0.14,2.58,0.24,3.94,0.24h1.32l0.05-11.7h-1.26
C393.74,96.75,387.41,94.79,387.41,85.92z"></path>
    <path fill="#ffffff" d="M421.55,63.93v-7.78H409.2v25.63v26.67h12.35v-27.5c0-8.61,5.5-14.01,14.11-14.01
c1.97,0,3.74,0.21,5.19,0.52V55.42c-0.52-0.1-2.38-0.31-3.73-0.31C429.64,55.11,424.04,58.54,421.55,63.93z"></path>
    <path fill="#ffffff" d="M471.29,54.6c-15.88,0-28.54,12.03-28.54,27.7c0,15.66,12.66,27.7,28.54,27.7
c15.77,0,28.53-12.04,28.53-27.7C499.82,66.63,487.06,54.6,471.29,54.6z M471.29,98.69c-9.23,0-16.18-7.16-16.18-16.39
c0-9.24,6.95-16.4,16.18-16.4c9.13,0,16.18,7.16,16.18,16.4C487.47,91.53,480.42,98.69,471.29,98.69z"></path>
              <polygon fill="#ffffff" points="507.48,69.05 507.48,108.44 519.94,108.44 519.94,69.55 519.94,36.12 507.48,36.12"></polygon>
    <path fill="#ffffff" d="M564.84,86.55c0,8.3-4.88,11.83-11.42,11.83c-6.54,0-11.41-3.53-11.41-11.72V56.15h-12.56V71.3v16.4
c0,14.94,10.89,22.1,23.87,22.1c13.07,0,24.07-7.26,24.07-22.41V71.3V56.15h-12.55V86.55z"></path>
    <polygon fill="#ffffff" points="624.5,91.72 616.65,80.74 626.37,67.5 634.7,56.15 621.11,56.15 609.8,71.82 598.38,56.15
  584.9,56.15 592.63,66.73 602.95,80.84 592.14,95.91 583.13,108.44 596.52,108.44 609.8,89.97 623.08,108.44 636.46,108.44"></polygon>
            </g>
  <path id="shape" fill="#ffffff" d="M0,146.13h146.11V0H0V146.13z M93.65,11.16c25.83,8.46,44.49,32.95,44.56,61.87
    c0.07,28.46-18.22,52.88-44.56,61.9V11.16z M73.03,7.85c4.67,0,9.64,0.62,13.78,1.45c0,33.1-32.02,60.35-65.06,60.35L7.93,69.63
    C10.2,35.69,38.28,7.85,73.03,7.85z M21.76,76.54c33.04,0,65.04,27.22,65.04,60.29c-4.13,0.84-9.35,1.47-13.77,1.47
  c-34.77-0.05-63.8-27.97-65.11-61.76H21.76z"></path>
          </svg>
        }

        <div class="footer-links d-none d-md-block">
          <a [routerLink]="currentLang() ? [currentLang(),'feedback'] : ['/feedback']">
            {{'link-feedback' | translate}}
          </a>

          <a href="#" data-bs-target="#rules" data-bs-toggle="modal">
            {{'link-rules' | translate}}
          </a>

          <a href="#" data-bs-target="#policy" data-bs-toggle="modal">
            {{'link-policy' | translate}}
          </a>
          <!-- <a href='/rules' data-bs-toggle="modal" data-bs-target="#faq">
          {{ 'link-faq' | translate }}
        </a> -->
        <!-- <a href='/policy' data-bs-toggle="modal" data-bs-target="#policy">
        {{ 'link-policy' | translate }}
      </a> -->
      <!-- <a [routerLink]="['/', currentLang, 'cookie']">
      {{ 'link-cookie' | translate }}
    </a> -->

    <!-- <a href="#" routerLink="/feedback">
    {{ 'link-feedback' | translate }}
  </a> -->
</div>
</div>

</div>
</footer>
</section>
